{
  "ResourceRowGallery": {
    "failedToLoad": "Failed to load pins",
    "empty": "No pins yet",
    "addContactPins": "Add pins"
  },
  "TransferResourceDialog": {
    "title": "Transfer to workspace",
    "description_one": "Move {{name}} to another workspace.",
    "description_other": "Move {{count}} resources to another workspace.",
    "fieldWorkspace": "Destination workspace",
    "success_one": "Resource transferred",
    "success_other": "{{count}} resources transferred"
  }
}
